module.exports = __webpack_public_path__ + "img/icon_print.3cb76ceb.png";